import * as React from 'react';
import classnames from 'classnames';
import { Util, useDrawer, Button } from '@grandvisionhq/common';

const FacetsMobileTrigger = /*#__PURE__*/ React.forwardRef(({ onClick , caption  }, outerRef)=>{
    const [isSticky1, setSticky] = React.useState(false);
    const innerRef = React.useRef(null);
    React.useImperativeHandle(outerRef, ()=>innerRef.current
    , []);
    const { isHidden: isHeaderHidden  } = Util.useHeaderOnScroll(true);
    const { toggle  } = useDrawer();
    const handleClick = ()=>{
        onClick();
        toggle();
    };
    const handleScroll = React.useCallback(()=>{
        if (innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) {
            // Scrolling up reveals the Header, which is 62px in height
            const benchmark = isHeaderHidden ? 0 : 62;
            const isSticky = innerRef.current.getBoundingClientRect().top < benchmark;
            setSticky(isSticky);
        }
    }, [
        isHeaderHidden,
        setSticky,
        innerRef
    ]);
    // Adds scroll listener that makes the filterbutton sticky
    React.useEffect(()=>{
        window.addEventListener('scroll', handleScroll);
        return ()=>window.removeEventListener('scroll', handleScroll)
        ;
    }, [
        handleScroll
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "facets-mobile-trigger",
        ref: innerRef
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames({
            'facets-mobile-trigger__sticky': isSticky1,
            'facets-mobile-trigger__sticky--with-header': !isHeaderHidden && isSticky1
        })
    }, /*#__PURE__*/ React.createElement(Button, {
        className: "facets-mobile-trigger__button",
        "data-t": "facets-mobile-button",
        caption: caption,
        icon: "filter",
        onClick: handleClick
    })));
});

export { FacetsMobileTrigger };
//# sourceMappingURL=FacetsMobileTrigger.js.map
